import { useState, useEffect } from "react";
import { Link, withRouter, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CssBaseline from "@material-ui/core/CssBaseline";
import IconButton from "@material-ui/core/IconButton";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import Badge from "@material-ui/core/Badge";
import Avatar from "@material-ui/core/Avatar";
import Dialog from "@material-ui/core/Dialog";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import "bootstrap/dist/css/bootstrap.css";
import Form from "react-bootstrap/Form";
import { FaPowerOff, FaRegEnvelope, FaLock } from "react-icons/fa";
import contendZONEViolet from "../../assets/images/contendZONEBlue.png";
import schoolIcon from "../../assets/images/schoolIcon.png";
import storageIcon from "../../assets/images/storageIcon.png";
import paymentIcon from "../../assets/images/paymentIcon.png";
import websiteIcon from "../../assets/images/websideIcon.png";
import successimg from "../../assets/images/successimg.png";
import dashboardIconnew from "../../assets/images/dashboardIconnew.png";
import ResetPasswordDialog from "../schoolAdminPortal/Popups/ResetPasswordDialog";
import Sidebar from "./Sidebar";
import {
  getFromLocalStorage,
  removeFromLocalStorage,
} from "../../utils/webStorage";
import userService from "../../services/user.service";
import { useDispatch } from "react-redux";
import "./superAdmin.css";
import NotificationContainer from "../schoolAdminPortal/NotificationContainer";
import { BsXLg } from "react-icons/bs";
import MobileNavigation from "./SuperAdminNavigation/MobileNavigation";
import { openSuccessPopup } from "../../Redux/Actions/PopupActions";
import { openFailDialog } from "../../Redux/Actions/PopupActions";
const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },

  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    color: "white",
    background: "#01173E",
  },
  drawerContainer: {
    overflow: "auto",
  },
  dropdownbutton: {
    margin: theme.spacing(1),
    background: "#003594",
    color: "#FFFFFF",
    borderRadius: "22px",
    width: "80%",
    fontFamily: "Rajdhani-SemiBold",
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },

  dropdown: {
    position: "absolute",
    right: 0,
    left: "8px",
    zIndex: 1,
    padding: theme.spacing(0, 1),
    backgroundColor: "#003594",
    width: "80%",
    top: "108px",
    color: "#FFFFFF",
    borderRadius: "22px",
    textAlign: "center",
    fontFamily: "Rajdhani-SemiBold",
  },
  innerdropdown: {
    color: "#FFFFFF",
    fontFamily: "Rajdhani-SemiBold",
  },
  grow: {
    flexGrow: 1,
    textAlign: "right",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },

  inputRoot: {
    color: "inherit",
    background: "orange",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  tabs: {
    background: "#003594",
  },
}));

const MiniDrawer = (props) => {
  const textProfile = {
    color: "black",
    textAlign: "right",
  };
  const { history } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [unReadCount, setUnReadCount] = useState(null);
  const [anchorElog, setAnchorElog] = useState(null);
  const [notificationData, setNotificationData] = useState([]);
  const [UserName, setUserName] = useState(null);
  const [adminRole, setadminRole] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const dispatch = useDispatch();
  const lolcation = useLocation();
  const isMenuOpen = Boolean(anchorEl);
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const isMenuOpenNoti = Boolean(anchorElog);
  const handleProfileMenuOpen1 = (event) => {
    setAnchorElog(event.currentTarget);
  };
  useEffect(() => {
    var UserName = getFromLocalStorage("loginUser");
    var adminRole = getFromLocalStorage("loginRole");
    var adminEmail = getFromLocalStorage("superAdminEmail");
    setUserName(UserName);
    setadminRole(adminRole);
    setOldEmail(adminEmail);
  }, []);

  useEffect(() => {
    userService.getNotificationData().then((response) => {
      const data = response.data.data.notifications;
      setNotificationData(data);
      setUnReadCount(response.data.data.unreadCount);
    });
  }, []);

  function logout() {
    removeFromLocalStorage("user");
    window.localStorage.clear();
    history.push("/login");
  }

  const menuId = "primary-search-account-menu";

  const itemsList = [
    {
      text: "Dashboard",
      icon: <img src={dashboardIconnew} alt="dashboard"></img>,
      onClick: () => history.push("/dashboarddata"),
    },
    {
      text: "School",
      icon: <img src={schoolIcon} alt="school"></img>,
      onClick: () => history.push("/schools"),
    },
    {
      text: "Storage",
      icon: <img src={storageIcon} alt="storage"></img>,
      onClick: () => history.push("/storage"),
    },
    {
      text: "Payments",
      icon: <img src={paymentIcon} alt="payment"></img>,
      onClick: () => history.push("/payment"),
    },
    {
      text: "Website",
      icon: <img src={websiteIcon} alt="website"></img>,
      onClick: () => history.push("/website"),
    },
  ];

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [openReset, setOpenReset] = useState(false);
  //change email pop up
  const [openChange, setOpenChange] = useState(false);
  //sucess pop up
  const [openSuccess, setOpenSuccess] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [openValidationPop, setOpenValidationPop] = useState(false);
  const [oldEmail, setOldEmail] = useState("");
  const [emailValidation, setEmailValidation] = useState(false);
  const submitResetPassword = async (values, setSubmitting) => {
    setSubmitting(true);
    const { oldPassword, password, confirmPassword } = values;
    setOpenReset(false);
    userService
      .resetPasswordSuperAdmin(oldPassword, password, confirmPassword)
      .then((response) => {
        setSubmitting(false);
        openSuccessPopup(dispatch, {
          successPopUp: {
            message: "Password changed successfully.",
            open: true,
          },
        });
        logout();
      })
      .catch((error) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Something went wrong!",
        });
      });
    setSubmitting(false);
  };

  //sucess pop ups
  const handleClickSucess = () => {
    setOpenSuccess(true);
    setOpenReset(false);
  };

  const handleClickCloseSucess = () => {
    setOpenSuccess(false);
  };
  const [openChangeSuccess, setOpenChangeSuccess] = useState(false);
  //sucess pop ups
  const handleClickChangeSucess = () => {
    setOpenChangeSuccess(true);
  };

  // const markAllReadPost = () => {
  //   userService
  //     .readAllNotificationPost()
  //     .then((response) => {
  //       loadDataOnlyNotification();
  //     })
  //     .catch((error) => {
  //       console.error("There was an error!", error);
  //     });
  // };

  const handleClickCloseChangeSucess = () => {
    setOpenChangeSuccess(false);
  };
  //
  /////sidebar Dropdown
  // const [openside, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  const handleClickAway = () => {
    setOpen(false);
  };
  const handleClickToOpenReset = () => {
    setOpenReset(true);
  };

  const handleToCloseReset = () => {
    setOpenReset(false);
  };
  //change email
  const handleClickToOpenChange = () => {
    setOpenChange(true);
  };

  const handleToCloseChnage = () => {
    setOpenChange(false);
  };
  // const onClickDelete = (id) => {
  //   userService
  //     .deleteNotificationPost(id)
  //     .then((response) => {
  //       loadDataOnlyNotification();
  //     })
  //     .catch((error) => {
  //       console.error("There was an error!", error);
  //     });
  // };
  // const unReadNotificationPost = (id) => {
  //   userService
  //     .readNotificationPost(id)
  //     .then((response) => {
  //       loadDataOnlyNotification();
  //     })
  //     .catch((error) => {
  //       console.error("There was an error!", error);
  //     });
  // };
  const handleMenuCloseNoti = () => {
    setAnchorElog(null);
  };

  // const loadDataOnlyNotification = () => {
  //   setSubmitting(true);
  //   userService
  //     .getNotificationData()
  //     .then((response) => {
  //       var arr = response.data.data.notifications;
  //       setnotification(arr);
  //       setNotificationCount(response.data.data.total);
  //       setUnReadCount(response.data.data.unreadCount);
  //       setTotalPages(response.data.data.totalPages);
  //       setSubmitting(false);
  //     })
  //     .catch((error) => {
  //       console.error("There was an error!", error);
  //     });
  // };

  const handleClickCheckOpen = () => {
    setDisabled(true);
    if (newEmail != "" && emailError == "") {
      setOpenValidationPop(true);
      setEmailValidation(false);
      setDisabled(false);
    }
    if (newEmail == "") {
      setEmailValidation(true);
      setEmailError("");
      setDisabled(false);
    }
  };

  const handleClickCheckFalse = () => {
    setOpenValidationPop(false);
  };

  const changeEmailCall = () => {
    var adminEmail = getFromLocalStorage("superAdminEmail");
    userService
      .updateSuperAdminEmail(newEmail, adminEmail)
      .then((response) => {
        handleClickChangeSucess();
      })
      .catch((error) => {});
  };

  const setNewEmailCall = (email) => {
    setNewEmail(email);
    setEmailValidation(false);
    if (email.length > 8) {
      userService.checkEmailInUser(email).then((response) => {
        if (response.data.data === "true") {
          setEmailError("Email is already exist! Please try with another!");
        } else {
          setEmailError("");
        }
      });
    }
  };

  const signOutClick = () => {
    removeFromLocalStorage("user");
    window.localStorage.clear();
    handleClickCloseChangeSucess();
  };

  const setUnreadCountZero = () => {
    setUnReadCount(null);
  };
  //
  const renderMenu = (
    <Menu
      className="mt30"
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem className="profile-menuu-barr" onClick={handleClickToOpenReset}>
        <div className="black profile-menu-barr">
          <FaLock className="profile-menu-iconss" />
          Change Password
        </div>
      </MenuItem>
      <MenuItem
        className="profile-menuu-barr"
        onClick={handleClickToOpenChange}
      >
        <div className="black profile-menu-barr">
          <FaRegEnvelope className="profile-menu-iconss" />
          Change Email ID
        </div>
      </MenuItem>
      <MenuItem className="profile-menuu-barr" onClick={logout}>
        <div className="black profile-menu-barr">
          <FaPowerOff className="profile-menu-iconss" />
          Logout
        </div>
      </MenuItem>
    </Menu>
  );
  const renderMenuNew = (
    <div className="notitab">
      <Menu
        className=" mt30 "
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        id="notificationList"
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMenuOpenNoti}
        onClose={handleMenuCloseNoti}
      >
        <NotificationContainer
          closeMenu={handleMenuCloseNoti}
          notificationUnReadCount={unReadCount}
          setUnReadCount={setUnReadCount}
          handleClick={setUnreadCountZero}
        />
      </Menu>
    </div>
  );

  return (
    <div id="hideSAdminDash" className={classes.root}>
      <CssBaseline />
      <AppBar id="userProfile" position="fixed" className={classes.appBar}>
        <MobileNavigation></MobileNavigation>

        <Toolbar>
          <div>
            <Link to="/superadmindashboard">
              <img src={contendZONEViolet} alt="Logo" noWrap />
            </Link>
          </div>
          <div className={classes.grow}>
            <IconButton
              aria-label="show 17 new notifications"
              color="inherit"
              onClick={handleProfileMenuOpen1}
            >
              <Badge badgeContent={unReadCount} color="secondary">
                <NotificationsNoneIcon />
              </Badge>
            </IconButton>
            <IconButton
              id="username"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <ListItem style={textProfile}>
                <ListItemText
                  id="textPro"
                  style={{ textTransform: "capitalize" }}
                  primary={UserName}
                  secondary={adminRole}
                />
              </ListItem>
              <Avatar src="/broken-image.jpg" />
              {/* <AccountCircle /> */}
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMenu} {renderMenuNew}
      {/* all modal pop up */}
      <ResetPasswordDialog
        submitResetPassword={submitResetPassword}
        openReset={openReset}
        handleToCloseReset={handleToCloseReset}
      />
      {/* change emaill pop up */}
      <Dialog open={openChange} onClose={handleToCloseChnage} id="Change_Email">
        <DialogTitle>
          <div className="row">
            <div className="col-11 col-lg-11 col-md-11">
              <label className="fs-18 semibold mb-0">
                Change Registered Email
              </label>
            </div>
            <div className="col-1 text-right ml-auto">
              <BsXLg
                onClick={handleToCloseChnage}
                className="crossview cp"
              ></BsXLg>
            </div>
          </div>
        </DialogTitle>
        <hr className="mt-0 mb-0"></hr>
        <DialogContent>
          <DialogContentText>
            <Form>
              <Form.Group>
                <Form.Label className="changeEmailtxt">Enter Email</Form.Label>
                <Form.Control
                  type="email"
                  className="txtboxChange"
                  placeholder="exisitngemail@sample.com"
                  onChange={(e) => setNewEmailCall(e.target.value)}
                />
              </Form.Group>
              {emailValidation == true && (
                <Form.Label className="changeEmailtxt1">
                  Email is required
                </Form.Label>
              )}
              <Form.Label className="changeEmailtxt1">{emailError}</Form.Label>
            </Form>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="d-block p-0">
          <div className="row px-1 float-end">
            <div className="col-6 col-lg-6 text-right">
              <button
                className="btn btn-cancel fs-16 mb-3"
                onClick={handleToCloseChnage}
              >
                Cancel
              </button>
            </div>
            <div className="col-6 col-lg-6 text-left">
              <button
                type="submit"
                className={disabled ? "btn-save-active" : "btn-save"}
                onClick={handleClickCheckOpen}
              >
                Update
              </button>
            </div>
          </div>
        </DialogActions>

        <div className="clear20"></div>
      </Dialog>
      {/* sucess pop up */}
      <Dialog
        id="ChnagePassSucess"
        className="dialog-style"
        open={openSuccess}
        onClose={handleClickCloseSucess}
      >
        <DialogTitle>
          <div className="row">
            <div className="col-1 text-right ml-auto "></div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="row">
            <div className="col-12 text-center">
              <img
                src={successimg}
                alt="success"
                className="successimg-new"
              ></img>
              <div className="clear20"></div>
              <p className="fs-20 semi-bold text-center">
                Password changed successfully.
              </p>
              <div className="clear30"></div>
            </div>
            <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
              <Link className="">
                <button type="button" class="donebtn" onClick={logout}>
                  DONE
                </button>
              </Link>
            </div>
          </div>

          <div className="clear10"></div>

          <div className="clear10"></div>
        </DialogContent>
      </Dialog>
      {/* school remove pop up */}
      <Dialog
        id="dialogBoxRemove"
        className="dialog-style"
        open={openValidationPop}
        onClose={handleClickCheckFalse}
      >
        <DialogTitle>
          <div className="row">
            <div className="col-1 text-right ml-auto mr-4">
              <BsXLg
                onClick={handleClickCheckFalse}
                className="crossview cp"
              ></BsXLg>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="clear10"></div>
          <div className="row">
            <div className="col-12 text-center">
              <p className="fs-20 semi-bold text-center">
                Are you sure you want to change the login email id?
              </p>
              <div className="clear20"></div>
            </div>
            <div className="col-5 col-md-3 col-lg-3 ml-auto text-center mr-3">
              <button
                type="button"
                class="cancelbtn"
                onClick={handleClickCheckFalse}
              >
                No
              </button>
            </div>
            <div className="clear10"></div>
            <div className="col-5 col-md-3 col-lg-3 mr-auto text-center mr-3">
              {/* <Link className="" to="/schoolCoaches"> */}
              <button type="button" class="yes-btn" onClick={changeEmailCall}>
                Yes, Update
              </button>
              {/* </Link> */}
            </div>
          </div>
          <div className="clear10"></div>
          <div className="clear10"></div>
        </DialogContent>
      </Dialog>
      {/* end  */}
      {/* Change Sucess */}
      <Dialog
        id="ChnageEmailSucess"
        className="dialog-style"
        open={openChangeSuccess}
        onClose={handleClickCloseChangeSucess}
      >
        <DialogTitle>
          <div className="row">
            <div className="col-1 text-right ml-auto "></div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="row">
            <div className="col-12 text-center">
              <img
                src={successimg}
                alt="success"
                className="successimg-new"
              ></img>
              <div className="clear20"></div>
              <p className="fs-20 semi-bold text-center">
                Email changed successfully. You will be logged out and need to
                login again.
              </p>
              <div className="clear30"></div>
            </div>
            <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
              <Link to="/login" className="">
                <button type="button" class="donebtn" onClick={signOutClick}>
                  DONE
                </button>
              </Link>
            </div>
          </div>

          <div className="clear10"></div>

          <div className="clear10"></div>
        </DialogContent>
      </Dialog>
      {/*  */}
      <Sidebar />
    </div>
  );
};

export default withRouter(MiniDrawer);
